import React, { memo, forwardRef } from "react";
const SvgCapitalE = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M13.56 16.84v4h6.18c.267 0 .48.04.64.12.16.08.28.18.36.3.093.12.153.247.18.38.027.12.04.227.04.32s-.013.207-.04.34a.912.912 0 01-.18.36c-.08.12-.2.22-.36.3-.16.08-.373.12-.64.12h-7.2c-1 0-1.5-.5-1.5-1.5V10.42c0-1 .5-1.5 1.5-1.5h6.82c.267 0 .48.04.64.12.173.08.3.18.38.3.093.12.153.247.18.38.027.12.04.22.04.3 0 .08-.013.187-.04.32a.912.912 0 01-.18.36.887.887 0 01-.38.3c-.16.08-.373.12-.64.12h-5.8v3.6h5.48c.267 0 .48.04.64.12.16.08.28.18.36.3.08.107.133.22.16.34.027.12.04.22.04.3 0 .08-.013.18-.04.3-.027.12-.08.24-.16.36-.08.107-.2.2-.36.28-.16.08-.373.12-.64.12h-5.48z"
      />
    </svg>
  );
});
SvgCapitalE.displayName = "SvgCapitalE";
const MemoForwardRef = memo(SvgCapitalE);
export default MemoForwardRef;
